import { PageUrl } from "src/routes/PageUrl";

// Разделы, которые должны активироваться в левом меню для каждой страницы
export type PartitionUrl =
  | PageUrl.catalogs
  | PageUrl.classifiers
  | PageUrl.docs
  | PageUrl.home
  | PageUrl.managementCatalogs
  | PageUrl.managementExtensions
  | PageUrl.managementUsers
  | PageUrl.managementWorkflows
  | PageUrl.workflowStreams;

const objManagement: PartitionUrl = PageUrl.managementCatalogs;
const users: PartitionUrl = PageUrl.managementUsers;

export const leftMenuActivePartitions: Record<PageUrl, PartitionUrl | null> = {
  [PageUrl.home]: PageUrl.home,
  [PageUrl.test]: null,
  [PageUrl.cardDemo]: null,
  [PageUrl.tableDemo]: null,
  [PageUrl.customTableDemo]: null,
  [PageUrl.mformDemo]: null,
  [PageUrl.newRecordWf]: null,
  [PageUrl.editRecordWf]: null,
  [PageUrl.docs]: PageUrl.docs,
  [PageUrl.classifiers]: PageUrl.classifiers,
  [PageUrl.managementCatalogs]: objManagement,
  [PageUrl.managementCatalogNew]: objManagement,
  [PageUrl.managementCatalogEdit]: objManagement,
  [PageUrl.managementCatalogAccess]: objManagement,
  [PageUrl.managementClassifiers]: objManagement,
  [PageUrl.managementClassifierCard]: objManagement,
  [PageUrl.managementClassifierAccess]: objManagement,
  [PageUrl.managementPrimSpecs]: objManagement,
  [PageUrl.managementPrimSpecCard]: objManagement,
  [PageUrl.managementUsers]: users,
  [PageUrl.managementUserEdit]: users,
  [PageUrl.managementUserNew]: users,
  [PageUrl.managementRoles]: users,
  [PageUrl.managementRoleEdit]: users,
  [PageUrl.managementRoleNew]: users,
  [PageUrl.managementSecondSpecs]: objManagement,
  [PageUrl.managementSecondSpecCard]: objManagement,
  [PageUrl.managementValueSpecs]: objManagement,
  [PageUrl.managementValueSpecCard]: objManagement,
  [PageUrl.managementValueCatalogs]: objManagement,
  [PageUrl.managementValueCatalogNew]: objManagement,
  [PageUrl.managementValueCatalogEdit]: objManagement,
  [PageUrl.managementWorkflows]: PageUrl.managementWorkflows,
  [PageUrl.managementWorkflowNew]: PageUrl.managementWorkflows,
  [PageUrl.managementWorkflowCard]: PageUrl.managementWorkflows,
  [PageUrl.managementExtensions]: PageUrl.managementExtensions,
  [PageUrl.managementExtensionNew]: PageUrl.managementExtensions,
  [PageUrl.managementExtensionCard]: PageUrl.managementExtensions,
  // в отличие от каталогов, у которых пользовательская часть имеет свой раздел меню, здесь это часть админки
  [PageUrl.valueCatalog]: objManagement,
  [PageUrl.valueCatalogNew]: objManagement,
  [PageUrl.valueCatalogEdit]: objManagement,
  [PageUrl.classes]: PageUrl.classifiers,
  [PageUrl.newClass]: PageUrl.classifiers,
  [PageUrl.class]: PageUrl.classifiers,
  [PageUrl.catalogs]: PageUrl.catalogs,
  [PageUrl.records]: PageUrl.catalogs,
  [PageUrl.newRecord]: PageUrl.catalogs,
  [PageUrl.editRecord]: PageUrl.catalogs,
  [PageUrl.recordHistory]: PageUrl.catalogs,
  [PageUrl.workflowStreams]: PageUrl.workflowStreams,
  [PageUrl.workflowCards]: PageUrl.workflowStreams,
};
